import React from 'react';
import dataProvider from './../../common/dataProvider';
import Groups from './calleridgroups';
import Items from './calleriditems';
import {Route, Routes} from 'react-router-dom';

class Index extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: {data:[], metadata: []}
        }
    }
    componentDidMount() {
        this.loadFromServer();
    }
    loadFromServer() {
        const url = `/admin/products/calleridgroups`;
        dataProvider.getList(url, {}).then(
            response => 
            this.setState({
                loading: false,
                data: response.data
            })
        );
    }
    render() {
        return (
            <div>
                <Routes>
                    <Route 
                        path="/products/calleridgroups" 
                        exact 
                        render={
                            (props) => <Groups {...props} data={this.state.data} childProps={this.props.childProps}/>
                        } />
                    <Route 
                        path="/products/calleridgroups/:group_id" 
                        exact 
                        render={
                            (props) => <Items {...props} data={this.state.data} childProps={this.props.childProps}/>
                        } />
                </Routes>
            </div>
        )
    }
}

export default Index;